import React, { useState, Fragment, useEffect, useMemo } from "react";
import {
  Box,
  Button,
  Card,
  CircularProgress,
  Divider,
  Grid,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";

import MucA from "../Muc/MucA";
import MucA0 from "../Muc/MucA0";
import MucB from "../Muc/MucB";
import MucC from "../Muc/MucC";
import MucD from "../Muc/MucD";
import MucE from "../Muc/MucE";

import ThanhTichInsert from "../ThanhTichInsert";
import PreviewModal from "../../../components/CommonComponents/PreviewModal";

import { getError } from "../../../components/KPTComponents/KPTextform/utils";
import { textForm, textFormDanhGia } from "../utils";
import { DEFAULT_ERROR } from "../../../components/KPTComponents/KPTextform/KPTextform";
import {
  apiCall,
  convertBeToFe,
  convertFeToBe,
  jumpToReleventDiv,
  toPlural,
} from "../../../utils";
import {
  councilActions,
  formActions,
  profileActions,
  userActions,
} from "../../../actions";
import {
  CRUD_LABELS,
  CRUD_MODELS,
  COLOR_PALETTE,
  FORM_MODEL,
  PROFILE_MODEL,
  FORM_CONSTANTS,
  HEADERS,
  FORM_MODEL_DANH_GIA,
  EDUCATE_DEGREE_CONSTANTS,
  TRAINEE_GUIDANCE_CONSTANTS,
} from "../../../constants";
import PopupMenu from "../../../components/CommonComponents/PopupMenu";
import { useParams } from "react-router-dom";
import MucDanhGiaA0 from "../DanhGia/MucA0";
import { use } from "react";
import MucDanhGiaNhanXet from "../DanhGia/MucNhanXet";
import DefaultLabel from "../../../components/CommonComponents/DefaultLabel";

const TitleHeader = ({ id, title, marginTop }) => {
  return (
    <Card id={id} style={{ width: "100%", marginTop }}>
      <Box height={6} bgcolor={COLOR_PALETTE.PRIMARY} />
      <Box p={2}>
        <Typography
          variant="h5"
          style={{
            // fontFamily: "Roboto-bold",
            fontFamily: "Roboto",
            textAlign: "center",
            textTransform: "uppercase",
          }}
        >
          <b>{title}</b>
        </Typography>
      </Box>
    </Card>
  );
};

const DEFAULT_DELETE_CRUD_STATE = {
  type: "",
  anchorEl: null,
  handleDelete: null,
};

function DangKyHoSoUpdate() {
  const dispatch = useDispatch();

  const { id } = useParams();
  const { form, profile, councils } = useSelector((state) => ({
    form: state.formReducer.form,
    councils: state.formReducer?.form?.councils || [],
    profile: state.profileReducer.profile,
  }));

  const thamDinhCode = useMemo(() => {
    if (councils.length > 0) {
      const council = councils.find((c) => c?.profileId === profile?.id);
      return council?.code || "";
    }
    return "";
  }, [councils]);

  const thamDinhData = useMemo(() => {
    if (councils.length > 0) {
      const council = councils.find((c) => c?.profileId === profile?.id);
      return council || {};
    }
    return {};
  }, [councils]);

  const disabled = profile?.submittable == false;

  const [formThamDinh, setFormThamDinh] = useState([]);

  const [values, setValues] = useState(null);
  const [valueThamDinh, setValuesThamDinh] = useState(null);
  const [preview, setPreview] = useState(null);
  const [profileValues, setProfileValues] = useState(null);

  const [error, setError] = useState({ ...DEFAULT_ERROR });
  const [dialog, setDialog] = useState(null);
  const [deleteCrud, setDeleteCrud] = useState({
    ...DEFAULT_DELETE_CRUD_STATE,
  });

  const handleReload = () => {
    // console.log("handleReload", id);
    if (id) {
      dispatch(formActions.getApplicationFormById(id));
      dispatch(formActions.getStat(id));
    } else {
      dispatch(
        formActions.filterApplicationForm({ profileId: profile.id })
      ).then(async (res) => {
        if (res) {
          dispatch(formActions.getApplicationFormById(res.id));
          dispatch(formActions.getStat(res.id));
        } else {
          await saveForm({ status: FORM_CONSTANTS.STATUS_MAP.draft.value });
        }
      });
    }
  };

  const closeDeleteMenu = () => {
    setDeleteCrud({ ...DEFAULT_DELETE_CRUD_STATE });
  };

  const saveForm = async (additionalValues = {}) => {
    const _payload = {
      ...values,
      ...additionalValues,
      profileId: values?.profileId || profile.id,
    };
    // console.log("saveForm: _payload", _payload);
    const converted = await convertFeToBe(
      _payload,
      FORM_MODEL,
      "/form/" + _payload.id
    );

    if (converted.error) {
      dispatch(
        userActions.notification({ message: converted.error, type: "error" })
      );
      return;
    }

    const payload = { ...converted.values };
    Object.keys(CRUD_MODELS).forEach((_key) => {
      const key = toPlural(CRUD_MODELS[_key]);
      if (payload.hasOwnProperty(key)) payload[key] = undefined;
    });
    // console.log("payload", payload);

    if (payload.id) {
      dispatch(formActions.updateApplicationForm(payload));
    } else {
      dispatch(formActions.insertApplicationForm(payload)).then((success) => {
        if (success) window.location.reload();
      });
    }
  };
  // console.log("DangKyHoSoUpdate: form", form);

  const saveProfile = async () => {
    const converted = await convertFeToBe(
      { ...profileValues },
      PROFILE_MODEL,
      "/profile/" + profile.id
    );
    dispatch(profileActions.updateProfile(converted.values));
  };

  const validate = (values, textform) => {
    // console.log("validate", values, textform);
    for (const elm of textform) {
      const err = getError(values, elm);
      if (!!err) {
        // console.log("elm", elm, "err", err, "values", values);
        setError({ key: elm.key, value: err });
        jumpToReleventDiv(elm.key);
        dispatch(
          userActions.notification({
            message: `Không được để trống thông tin về: ${elm.label}`,
            type: "error",
          })
        );
        // window.history.pushState(null, null, `#${elm.key}`);
        return false;
      }
    }

    return true;
  };
  // console.log(values);

  const handleChangeForm = (name, event, type) => {
    let value;
    switch (type) {
      case "date":
        value = event;
        break;
      case "dropzone":
      case "richtext":
        value = event;
        break;
      case "checkbox":
        value = event.target.checked;
        break;
      default:
        value = event.target.value;
        break;
    }
    const exportDaiHocList = [];
    const exportThacSiList = [];
    const exportTienSiList = [];
    const exportTSKHList = [];
    const exportPGSList = [];
    // console.log(formThamDinh.mucA9);
    formThamDinh.mucA9?.forEach((item) => {
      const key = item.key;
      if (key.startsWith("xuat-daiHoc")) {
        exportDaiHocList.push(key);
      }
      if (key.startsWith("xuat-thacSi")) {
        exportThacSiList.push(key);
      }
      if (key.startsWith("xuat-tienSi")) {
        exportTienSiList.push(key);
      }
      if (key.startsWith("xuat-TSKH")) {
        exportTSKHList.push(key);
      }
      if (key.startsWith("xuat-PGS")) {
        exportPGSList.push(key);
      }
    });
    // console.log("exportDaiHocList", exportDaiHocList);

    if (name.startsWith("xuat-")) {
      // console.log("handleChangeForm", name, value, type);
      const newValues = { ...valueThamDinh };
      if (name?.includes("daiHoc")) {
        if (value) {
          for (const key of exportDaiHocList) {
            if (key !== name) {
              newValues[key] = false;
            }
          }
        }
      }
      if (name?.includes("thacSi")) {
        if (value) {
          for (const key of exportThacSiList) {
            if (key !== name) {
              newValues[key] = false;
            }
          }
        }
      }
      if (name?.includes("tienSi")) {
        if (value) {
          for (const key of exportTienSiList) {
            if (key !== name) {
              newValues[key] = false;
            }
          }
        }
      }
      if (name?.includes("TSKH")) {
        if (value) {
          for (const key of exportTSKHList) {
            if (key !== name) {
              newValues[key] = false;
            }
          }
        }
      }
      if (name?.includes("PGS")) {
        if (value) {
          for (const key of exportPGSList) {
            if (key !== name) {
              newValues[key] = false;
            }
          }
        }
      }
      newValues[name] = value;
      setValuesThamDinh(newValues);
    } else {
      const keys = name.split(".");
      const lastKey = keys.pop();
      const newValues = { ...valueThamDinh };

      var nestedObj = newValues;
      keys.forEach((k) => {
        if (!nestedObj[k]) nestedObj[k] = {};
        nestedObj = nestedObj[k];
      });
      nestedObj[lastKey] = value;

      setValuesThamDinh(newValues);

      if (error.key === name) setError({ ...DEFAULT_ERROR });
    }
  };

  const handleSaveDanhGia = () => {
    // console.log("formThamDinh", formThamDinh, valueThamDinh);
    const validateTextForm = [
      ...formThamDinh.mucA0,
      ...formThamDinh.mucA9,
      ...formThamDinh.mucA10,
      ...formThamDinh.mucB1,
      ...formThamDinh.mucB2,
      ...formThamDinh.mucB3,
      ...formThamDinh.mucB4,
      ...formThamDinh.mucC,
      ...formThamDinh.mucNhanXet,
    ];
    // // Bỏ check để lúc nào cũng có thể lưu đánh giá
    // const validatedForm = validate(valueThamDinh, validateTextForm);
    // if (!validatedForm) return;
    // console.log("valueThamDinh", valueThamDinh);

    const listDaiHoc = [];
    const listThacSi = [];
    const listTienSi = [];
    const listTSKH = [];
    const listPGS = [];
    const listTraineeGuidances = [];
    const listScientificTasks = [];
    const listReseachProjects = [];
    for (const key of Object.keys(valueThamDinh)) {
      if (key.startsWith("daiHoc")) {
        const splitKey = key.split("-");
        if (splitKey.length > 1) {
          const index = splitKey[1];
          listDaiHoc.push(`${valueThamDinh[key]}-${index}`);
          delete valueThamDinh[key];
        }
      }
      if (key.startsWith("thacSi")) {
        const splitKey = key.split("-");
        if (splitKey.length > 1) {
          const index = splitKey[1];
          listThacSi.push(`${valueThamDinh[key]}-${index}`);
          delete valueThamDinh[key];
        }
      }
      if (key.startsWith("tienSi")) {
        const splitKey = key.split("-");
        if (splitKey.length > 1) {
          const index = splitKey[1];
          listTienSi.push(`${valueThamDinh[key]}-${index}`);
          delete valueThamDinh[key];
        }
      }
      if (key.startsWith("TSKH")) {
        const splitKey = key.split("-");
        if (splitKey.length > 1) {
          const index = splitKey[1];
          listTSKH.push(`${valueThamDinh[key]}-${index}`);
          delete valueThamDinh[key];
        }
      }
      if (key.startsWith("PGS")) {
        const splitKey = key.split("-");
        if (splitKey.length > 1) {
          const index = splitKey[1];
          listPGS.push(`${valueThamDinh[key]}-${index}`);
          delete valueThamDinh[key];
        }
      }
      if (key.startsWith("traineeGuidances")) {
        const splitKey = key.split("-");
        if (splitKey.length > 1) {
          const index = splitKey[1];
          listTraineeGuidances.push(`${valueThamDinh[key]}-${index}`);
          delete valueThamDinh[key];
        }
      }
      if (key.startsWith("scientificTasks")) {
        const splitKey = key.split("-");
        if (splitKey.length > 1) {
          const index = splitKey[1];
          listScientificTasks.push(`${valueThamDinh[key]}-${index}`);
          delete valueThamDinh[key];
        }
      }
      if (key.startsWith("researchProjects")) {
        const splitKey = key.split("-");
        if (splitKey.length > 1) {
          const index = splitKey[1];
          listReseachProjects.push(`${valueThamDinh[key]}-${index}`);
          delete valueThamDinh[key];
        }
      }
      if (key.startsWith("xuat-daiHoc")) {
        const splitKey = key.split("-");
        if (splitKey.length > 2) {
          const index = splitKey[2];
          if (valueThamDinh[key]) {
            valueThamDinh[`exportDaiHoc`] = index;
          }
          delete valueThamDinh[key];
        }
      }
      if (key.startsWith("xuat-thacSi")) {
        const splitKey = key.split("-");
        if (splitKey.length > 2) {
          const index = splitKey[2];
          if (valueThamDinh[key]) {
            valueThamDinh[`exportThacSi`] = index;
          }
          delete valueThamDinh[key];
        }
      }
      if (key.startsWith("xuat-tienSi")) {
        const splitKey = key.split("-");
        if (splitKey.length > 2) {
          const index = splitKey[2];
          if (valueThamDinh[key]) {
            valueThamDinh[`exportTienSi`] = index;
          }
          delete valueThamDinh[key];
        }
      }
      if (key.startsWith("xuat-TSKH")) {
        const splitKey = key.split("-");
        if (splitKey.length > 2) {
          const index = splitKey[2];
          if (valueThamDinh[key]) {
            valueThamDinh[`exportTienSiKhoaHoc`] = index;
          }
          delete valueThamDinh[key];
        }
      }
      if (key.startsWith("xuat-PGS")) {
        const splitKey = key.split("-");
        if (splitKey.length > 2) {
          const index = splitKey[2];
          if (valueThamDinh[key]) {
            valueThamDinh[`exportPhoGiaoSu`] = index;
          }
          delete valueThamDinh[key];
        }
      }
    }
    valueThamDinh.daiHoc = listDaiHoc.join("||");
    valueThamDinh.thacSi = listThacSi.join("||");
    valueThamDinh.tienSi = listTienSi.join("||");
    valueThamDinh.TSKH = listTSKH.join("||");
    valueThamDinh.PGS = listPGS.join("||");
    valueThamDinh.traineeGuidances = listTraineeGuidances.join("||");
    valueThamDinh.scientificTasks = listScientificTasks.join("||");
    valueThamDinh.researchProjects = listReseachProjects.join("||");

    const form = {
      ...valueThamDinh,
      bangDaiHoc: valueThamDinh?.daiHoc || "",
      bangThacSi: valueThamDinh?.thacSi || "",
      bangTienSi: valueThamDinh?.tienSi || "",
      bangTienSiKhoaHoc: valueThamDinh?.TSKH || "",
      bangPhoGiaoSu: valueThamDinh?.PGS || "",
      traineeGuidances: valueThamDinh?.traineeGuidances || "",
      scientificTasks: valueThamDinh?.scientificTasks || "",
      researchProjects: valueThamDinh?.researchProjects || "",
    };
    // console.log("form", form);

    if (thamDinhData?.id) {
      const payload = {
        id: thamDinhData?.id,
        phanBienKhai: form,
      };
      dispatch(councilActions.updateById(payload)).then((success) => {
        if (success) {
          dispatch(
            userActions.notification({
              message: "Lưu đánh giá hồ sơ thành công.",
              type: "success",
            })
          );
          window.location.reload();
        }
      });
      // console.log("payload", payload);
    } else {
      dispatch(
        userActions.notification({
          message: `Xảy ra lỗi khi lưu đánh giá hồ sơ. Vui lòng thử lại sau.`,
          type: "error",
        })
      );
    }
  };

  const handleSubmit = async (status) => {
    if (status === "danh_gia") {
      handleSaveDanhGia();
      return;
    }
    if (status === FORM_CONSTANTS.STATUS_MAP.submitted.value) {
      const validateTextForm = [
        ...textForm.mucA0,
        ...textForm.mucA.muc7,
        ...textForm.mucA.muc8,
        ...textForm.mucB.muc1,
        ...textForm.mucB.muc2,
        ...textForm.mucB.muc9,
        ...textForm.mucC,
        ...textForm.mucE,
      ];

      const validatedForm = validate(values, validateTextForm);
      const validatedProfile = validate(profileValues, textForm.mucA.muc1_6);
      if (!validatedForm || !validatedProfile) return;
    }
    saveForm({ status });
    saveProfile();
  };

  // Vừa vào trang thì lấy thông tin hồ sơ luôn
  useEffect(() => {
    if (!isNaN(profile?.id)) {
      if (!form) handleReload();
      // if (!profileValues) setProfileValues({ ...profile });
    }
  }, [profile]);

  useEffect(() => {
    if (form) {
      setValues({ ...form, registeredMajor: "Kinh tế" });
      if (!profileValues)
        setProfileValues(convertBeToFe({ ...form.profile }, PROFILE_MODEL));

      // const hash = window.location.hash;
      // setTimeout(() => jumpToReleventDiv(hash.substring(1)), 1000);
    }
  }, [form]);

  // TH ĐB
  useEffect(() => {
    if (!values) return;
    if (values.foreignLanguage !== "other" && !!values.otherForeignLanguage) {
      setValues({ ...values, otherForeignLanguage: "" });
    }
  }, [values]);

  const mucProps = { error, values, setValues, dialog, setDialog };
  // console.log("error", error);
  const mucPropsThamDinh = {
    error,
    valueThamDinh,
    setValuesThamDinh,
    values,
    formThamDinh,
  };

  // set value for formThamDinh
  useEffect(() => {
    if (!values) return;
    let textFormA0 = [];
    if (values && values?.entity === "gv") {
      textFormA0 = textFormDanhGia.mucA0.filter(
        (item) => item.key == "giangVien"
      );
    }
    if (values && values?.entity === "gvtg") {
      textFormA0 = textFormDanhGia.mucA0.filter(
        (item) => item.key == "giangVienThinhGiang"
      );
    }
    let textFormA9 = [];
    const educateDegrees = values?.educateDegrees || [];
    educateDegrees.forEach((item) => {
      const degreeType = item.degreeType;
      const degree = EDUCATE_DEGREE_CONSTANTS.TYPE_OPTIONS.find(
        (option) => option.key === degreeType
      )?.title;
      if (degree) {
        textFormA9.push({
          ...FORM_MODEL_DANH_GIA.trinhDoDaoTao,
          key: `${degreeType}-${item.id}`,
          label: `Bằng cấp ${degree} - ${item.issuePlace}`,
          required: true,
          xs: 11,
        });
        textFormA9.push({
          key: `xuat-${degreeType}-${item.id}`,
          label: ``,
          labelRender: <DefaultLabel label={`Xuất file`} />,
          xs: 1,
          type: "checkbox",
        });
      }
    });
    let textFormA10 = [];
    if (values?.pgsStartTime && values?.pgsStartTime !== "") {
      textFormA10.push({
        ...FORM_MODEL_DANH_GIA.congNhanPgs,
        key: `ngayCongNhanPhoGiaoSu`,
        label: `Ngày công nhận PGS`,
        required: true,
        xs: 12,
      });
    }
    if (values?.pgsMajor && values?.pgsMajor !== "") {
      textFormA10.push({
        ...FORM_MODEL_DANH_GIA.congNhanPgs,
        key: `nganhPhoGiaoSu`,
        label: `Chuyên ngành PGS`,
        required: true,
        xs: 12,
      });
    }
    // B2
    let mucB2 = [];
    if (values?.educateProcess) {
      for (const [key, item] of Object.entries(values?.educateProcess)) {
        mucB2.push({
          ...FORM_MODEL_DANH_GIA.thoiGianDaoTao,
          key: `nam${item.id + 1}`,
          label: `Thời gian đào tạo ${item.schoolYear}`,
          required: true,
          xs: 6,
        });
      }
    }

    // B4
    let mucB4 = [];
    const traineeGuidances = values?.traineeGuidances || [];
    traineeGuidances.forEach((item) => {
      mucB4.push({
        ...FORM_MODEL_DANH_GIA.congNhan,
        key: `traineeGuidances-${item.id}`,
        label: `Hướng dẫn ${item.title} - ${
          TRAINEE_GUIDANCE_CONSTANTS.TARGET_OPTIONS.find(
            (option) => option.key === item.target
          )?.title || ""
        } - ${
          TRAINEE_GUIDANCE_CONSTANTS.ROLE_OPTIONS.find(
            (option) => option.key === item.role
          )?.title || ""
        }`,
        xs: 12,
      });
    });

    // B6
    const mucB6 = [];
    const scientificTasks = values?.scientificTasks || [];
    scientificTasks.forEach((item) => {
      mucB6.push({
        ...FORM_MODEL_DANH_GIA.congNhan,
        key: `scientificTasks-${item.id}`,
        label: `Công nhận nhiệm vụ khoa học: ${item.title}`,
        xs: 12,
      });
    });

    // B8
    const mucB8 = [];
    const researchProjects = values?.researchProjects || [];
    researchProjects.forEach((item) => {
      mucB8.push({
        ...FORM_MODEL_DANH_GIA.congNhan,
        key: `researchProjects-${item.id}`,
        label: `Công nhận: ${item.title}`,
        xs: 12,
      });
    });

    const thamDinhForm = {
      mucA0: textFormA0,
      mucA9: textFormA9,
      mucA10: textFormA10,
      mucB1: textFormDanhGia.mucB1,
      mucB2: mucB2,
      mucB3: textFormDanhGia.mucB3,
      mucB4: mucB4,
      mucB6: mucB6,
      mucB8: mucB8,
      mucC: textFormDanhGia.mucC,
      mucNhanXet: textFormDanhGia.mucNhanXet,
    };
    // console.log("thamDinhForm", thamDinhForm);
    setFormThamDinh(thamDinhForm);
  }, [values]);

  useEffect(() => {
    if (thamDinhData && Object.keys(thamDinhData).length > 0) {
      // set value for valueThamDinh
      const _valueThamDinh = {
        ...thamDinhData?.phanBienKhai,
        // daiHoc: thamDinhData?.phanBienKhai?.bangDaiHoc || "",
        // thacSi: thamDinhData?.phanBienKhai?.bangThacSi || "",
        // tienSi: thamDinhData?.phanBienKhai?.bangTienSi || "",
        // TSKH: thamDinhData?.phanBienKhai?.bangTienSi || "",
        // PGS: thamDinhData?.phanBienKhai?.bangPhoGiaoSu || "",
      };
      const bangDaiHoc = thamDinhData?.phanBienKhai?.bangDaiHoc || "";
      const bangThacSi = thamDinhData?.phanBienKhai?.bangThacSi || "";
      const bangTienSi = thamDinhData?.phanBienKhai?.bangTienSi || "";
      const bangTSKH = thamDinhData?.phanBienKhai?.bangTienSiKhoaHoc || "";
      const bangPGS = thamDinhData?.phanBienKhai?.bangPhoGiaoSu || "";
      const traineeGuidances =
        thamDinhData?.phanBienKhai?.traineeGuidances || "";

      const splitDaiHoc = bangDaiHoc.split("||");
      splitDaiHoc.forEach((item, index) => {
        if (item) {
          const [value, idx] = item.split("-");
          if (idx && idx != "undefined") {
            _valueThamDinh[`daiHoc-${idx}`] = value;
            if (thamDinhData?.phanBienKhai?.exportDaiHoc === idx) {
              _valueThamDinh[`xuat-daiHoc-${idx}`] = true;
            } else {
              _valueThamDinh[`xuat-daiHoc-${idx}`] = false;
            }
          }
        }
      });
      const splitThacSi = bangThacSi.split("||");
      splitThacSi.forEach((item, index) => {
        if (item) {
          const [value, idx] = item.split("-");
          if (idx && idx != "undefined") {
            _valueThamDinh[`thacSi-${idx}`] = value;
            if (thamDinhData?.phanBienKhai?.exportThacSi === idx) {
              _valueThamDinh[`xuat-thacSi-${idx}`] = true;
            } else {
              _valueThamDinh[`xuat-thacSi-${idx}`] = false;
            }
          }
        }
      });
      const splitTienSi = bangTienSi.split("||");
      splitTienSi.forEach((item, index) => {
        if (item) {
          const [value, idx] = item.split("-");
          if (idx && idx != "undefined") {
            _valueThamDinh[`tienSi-${idx}`] = value;
            if (thamDinhData?.phanBienKhai?.exportTienSi === idx) {
              _valueThamDinh[`xuat-tienSi-${idx}`] = true;
            } else {
              _valueThamDinh[`xuat-tienSi-${idx}`] = false;
            }
          }
        }
      });
      const splitTSKH = bangTSKH.split("||");
      splitTSKH.forEach((item, index) => {
        if (item) {
          const [value, idx] = item.split("-");
          if (idx && idx != "undefined") {
            _valueThamDinh[`TSKH-${idx}`] = value;
            if (thamDinhData?.phanBienKhai?.exportTienSiKhoaHoc === idx) {
              _valueThamDinh[`xuat-TSKH-${idx}`] = true;
            } else {
              _valueThamDinh[`xuat-TSKH-${idx}`] = false;
            }
          }
        }
      });
      const splitPGS = bangPGS.split("||");
      splitPGS.forEach((item, index) => {
        if (item) {
          const [value, idx] = item.split("-");
          if (idx && idx != "undefined") {
            _valueThamDinh[`PGS-${idx}`] = value;
            if (thamDinhData?.phanBienKhai?.exportPhoGiaoSu === idx) {
              _valueThamDinh[`xuat-PGS-${idx}`] = true;
            } else {
              _valueThamDinh[`xuat-PGS-${idx}`] = false;
            }
          }
        }
      });
      const splitTraineeGuidances = traineeGuidances.split("||");
      splitTraineeGuidances.forEach((item, index) => {
        if (item) {
          const [value, idx] = item.split("-");
          if (idx && idx != "undefined") {
            _valueThamDinh[`traineeGuidances-${idx}`] = value;
          }
        }
      });

      const splitScientificTasks =
        thamDinhData?.phanBienKhai?.scientificTasks?.split("||") || [];
      splitScientificTasks.forEach((item, index) => {
        if (item) {
          const [value, idx] = item.split("-");
          if (idx && idx != "undefined") {
            _valueThamDinh[`scientificTasks-${idx}`] = value;
          }
        }
      });

      const splitResearchProjects =
        thamDinhData?.phanBienKhai?.researchProjects?.split("||") || [];
      splitResearchProjects.forEach((item, index) => {
        if (item) {
          const [value, idx] = item.split("-");
          if (idx && idx != "undefined") {
            _valueThamDinh[`researchProjects-${idx}`] = value;
          }
        }
      });

      setValuesThamDinh(_valueThamDinh);
    }
  }, [thamDinhData]);
  // console.log("valueThamDinh", valueThamDinh);

  // useEffect(() => {
  //   // console.log("preview", preview, !preview);
  //   if (!preview) {
  //     dispatch(
  //       userActions.notification({
  //         message: "Không có minh chứng 1",
  //         type: "info",
  //       })
  //     );
  //     return;
  //   }
  // }, [preview]);

  if (!values)
    return (
      // <Box
      //   display="flex"
      //   justifyContent="center"
      //   alignItems="center"
      //   height="100vh"
      //   width="100%"
      //   sx={{ backgroundColor: COLOR_PALETTE.BACKGROUND }}
      // >
      //   <CircularProgress />
      // </Box>
      null
    );

  return (
    <Fragment>
      <form
        id="form-dkhs"
        onSubmit={(e) => {
          const status = e.nativeEvent.submitter.getAttribute("data-status");
          e.preventDefault();
          handleSubmit(status);
        }}
      >
        <TitleHeader id="muc_a0" marginTop={64} title="A0. Thông tin chung" />
        <MucA0 {...mucProps} />
        {thamDinhCode && <MucDanhGiaA0 {...mucPropsThamDinh} />}

        <TitleHeader marginTop={64} title="A. Thông tin cá nhân" />
        <MucA
          {...mucProps}
          setPreview={setPreview}
          setDeleteCrud={setDeleteCrud}
          profileValues={profileValues}
          setProfileValues={setProfileValues}
          thamDinhCode={thamDinhCode}
          mucPropsThamDinh={mucPropsThamDinh}
          handleChangeForm={handleChangeForm}
        />

        <TitleHeader
          marginTop={64}
          title="B. Tự khai theo tiêu chuẩn chức danh GS/PGS"
        />
        <MucB
          {...mucProps}
          setPreview={setPreview}
          saveForm={saveForm}
          thamDinhCode={thamDinhCode}
          mucPropsThamDinh={mucPropsThamDinh}
        />

        <TitleHeader marginTop={64} title="C. Báo cáo khoa học tổng quan" />
        <MucC
          {...mucProps}
          setPreview={setPreview}
          thamDinhCode={thamDinhCode}
          mucPropsThamDinh={mucPropsThamDinh}
        />

        <TitleHeader marginTop={64} title={"D. " + CRUD_LABELS.program} />
        <MucD {...mucProps} setPreview={setPreview} />

        <TitleHeader
          marginTop={64}
          title="E. Minh chứng bản xác nhận thực hiện nhiệm vụ đào tạo và nghiên cứu khoa học của giảng viên"
        />
        <MucE {...mucProps} setPreview={setPreview} />

        {thamDinhCode && <MucDanhGiaNhanXet {...mucPropsThamDinh} />}
      </form>

      <PreviewModal
        open={!!preview}
        url={preview}
        handleClose={() => setPreview(null)}
      />
      <ThanhTichInsert
        dialog={dialog}
        values={values}
        setValues={setValues}
        setDialog={setDialog}
        setPreview={setPreview}
      />
      <PopupMenu
        position="center"
        anchorEl={deleteCrud.anchorEl}
        handleClose={closeDeleteMenu}
        render={
          <>
            <Box p={2} width={320} maxWidth={320}>
              <Typography align="center">
                Xác nhận xoá <b>{CRUD_LABELS?.[deleteCrud.type]}</b>?
              </Typography>
            </Box>
            <Divider />
            <Grid container spacing={2} sx={{ p: 2 }}>
              <Grid item xs={6}>
                <Button fullWidth variant="outlined" onClick={closeDeleteMenu}>
                  Huỷ
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    deleteCrud.handleDelete();
                    closeDeleteMenu();
                  }}
                >
                  Xác nhận
                </Button>
              </Grid>
            </Grid>
          </>
        }
      />
    </Fragment>
  );
}

export default DangKyHoSoUpdate;
